module.exports = __webpack_public_path__ + "img/prayer-journal_B095GDFCS1.235f99ae.jpg";